export default __webpack_public_path__ + "static/media/pixellab--graphic-design--03--1200x900.626d41c2.jpg";